/*
 * Copyright (C) Ivo Ladage-van Doorn - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Ivo Ladage-van Doorn <ivol37@gmail.com>, 2024
 */
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { MenuOptions } from "./Menu";
import React, { Component } from "react";

interface SubMenuProps {
  menuItem: MenuOptions;
  location: any; // Location object from react-router
  navigate: (path: string) => void; // Navigation function
}

interface SubMenuState {
  currentTabIndex: number;
}

export function withRouter(Component: React.ComponentType<any>) {
  return (props: any) => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    return <Component {...props} navigate={navigate} location={location} params={params} />;
  };
}

class SubMenu extends Component<SubMenuProps, SubMenuState> {
  constructor(props: SubMenuProps) {
    super(props);
    this.state = {
      currentTabIndex: this.getTabIndexFromURL(),
    };
  }

  componentDidUpdate(prevProps: SubMenuProps, prevState: SubMenuState) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      // Update the tab index when the URL changes
      this.setState({ currentTabIndex: this.getTabIndexFromURL() });
    }
    if (prevState.currentTabIndex !== this.state.currentTabIndex) {
      this.scrollToTop();
    }
  }

  getTabIndexFromURL() {
    const { menuItem, location } = this.props;

    if (location.pathname.endsWith(menuItem.url)) return 0;

    if (menuItem.submenu) {
      for (let index = 0; index < menuItem.submenu.length; index++) {
        if (location.pathname.endsWith(menuItem.submenu[index].url)) {
          return index;
        }
      }
    }
    return 0;
  }

  handleTabSelect = (index: number) => {
    const { menuItem, navigate } = this.props;
    if (menuItem.submenu) {
      navigate(menuItem.url + menuItem.submenu[index].url);
    }
  };

  scrollToTop() {
    const div = document.querySelector(".page-container") as HTMLDivElement;
    if (div) div.scrollTop = 0;
  }

  render() {
    const { menuItem, location } = this.props;
    const { currentTabIndex } = this.state;

    if (!location.pathname.startsWith(menuItem.url)) {
      return <div />;
    }

    const menuId = menuItem.url.replace("/", "");

    return (
      <div color="primary" className="page-container" id={menuId}>
        <div color="secondary" className="content-container tabbed-content-container">
          <Tabs selectedIndex={currentTabIndex} onSelect={this.handleTabSelect}>
            <TabList>
              {menuItem.submenu?.map((submenu, index) => (
                <Tab key={index}>{submenu.name}</Tab>
              ))}
            </TabList>
            {menuItem.submenu?.map((submenu, index) => (
              <TabPanel key={index}>{submenu.component()}</TabPanel>
            ))}
          </Tabs>
        </div>
      </div>
    );
  }
}

export default withRouter(SubMenu);
